// the ?react directive comes from vite-plugin-svgr
import accessibility from './accessibility.svg?react'
import alertCircle from './alert-circle.svg?react'
import alertInfo from './alert-info.svg?react'
import alertTriangle from './alert-triangle.svg?react'
import applePay from './applepay.svg?react'
import arrowRight from './arrow-right.svg?react'
import arrowUp from './arrow-up.svg?react'
import centeredText from './centered-text.svg?react'
import check from './check.svg?react'
import checkCircle from './check-circle.svg?react'
import chevronDown from './chevron-down.svg?react'
import chevronLeft from './chevron-left.svg?react'
import chevronRight from './chevron-right.svg?react'
import chevronUp from './chevron-up.svg?react'
import creditCard from './creditcard.svg?react'
import crown from './crown.svg?react'
import edit from './edit.svg?react'
import ellipse from './ellipse.svg?react'
import envelope from './envelope.svg?react'
import euroSign from './euro-sign.svg?react'
import facebook from './facebook.svg?react'
import gear from './gear.svg?react'
import googlePay from './googlepay.svg?react'
import heart from './heart.svg?react'
import image from './image.svg?react'
import information from './information.svg?react'
import instagram from './instagram.svg?react'
import leftAlignedText from './left-aligned-text.svg?react'
import link from './link.svg?react'
import linkedin from './linkedin.svg?react'
import logo from './logo.svg?react'
import megaphone from './megaphone.svg?react'
import nestedEllipse from './nested-ellipse.svg?react'
import pause from './pause.svg?react'
import payPal from './paypal.svg?react'
import plus from './plus.svg?react'
import popup from './popup.svg?react'
import question from './question.svg?react'
import play from './play.svg?react'
import radio from './radio.svg?react'
import rightAlignedText from './right-aligned-text.svg?react'
import search from './search.svg?react'
import sepa from './sepa.svg?react'
import share from './share.svg?react'
import sound from './sound.svg?react'
import speechBubble from './speech-bubble.svg?react'
import spinner from './spinner.svg?react'
import star from './star.svg?react'
import stop from './stop.svg?react'
import trashCan from './trash-can.svg?react'
import upload from './upload.svg?react'
import user from './user.svg?react'
import video from './video.svg?react'
import volume from './volume.svg?react'
import whatsapp from './whatsapp.svg?react'
import wireTransfer from './wiretransfer.svg?react'
import x from './x.svg?react'

const icons = {
  accessibility,
  alertCircle,
  alertInfo,
  alertTriangle,
  applePay,
  arrowRight,
  arrowUp,
  centeredText,
  check,
  chevronDown,
  chevronLeft,
  chevronRight,
  chevronUp,
  checkCircle,
  creditCard,
  crown,
  edit,
  ellipse,
  envelope,
  euroSign,
  facebook,
  gear,
  googlePay,
  heart,
  image,
  information,
  instagram,
  link,
  linkedin,
  leftAlignedText,
  logo,
  megaphone,
  nestedEllipse,
  pause,
  payPal,
  plus,
  popup,
  question,
  play,
  radio,
  rightAlignedText,
  search,
  sepa,
  share,
  sound,
  speechBubble,
  spinner,
  star,
  stop,
  trashCan,
  upload,
  user,
  x,
  video,
  volume,
  whatsapp,
  wireTransfer,
} as const

export default icons
